module.exports = __webpack_public_path__ + "static/media/letter-correction.97e48dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/letter-correction.png
// module id = 359
// module chunks = 1